// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dynamic Service Page Styles */
.dynamic-service-page {
  min-height: 100vh;
  background: #fafafa;
}

/* Loading & Error States */
.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 2rem;
  text-align: center;
}

.loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e0e0e0;
  border-top-color: #1a1a2e;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.error-container h2 {
  color: #d32f2f;
  margin-bottom: 1rem;
}

/* Hero Section */
.dsp-hero-section {
  position: relative;
  min-height: 100vh;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding-top: 0;
  padding-bottom: 0;
}

.dsp-hero-gradient {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #0a0a1a 0%, #0f1520 40%, #141e30 70%, #0f0f1f 100%);
}

.dsp-hero-pattern {
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(circle at 20% 50%, rgba(74, 158, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(74, 158, 255, 0.08) 0%, transparent 40%),
    radial-gradient(circle at 40% 80%, rgba(44, 90, 160, 0.06) 0%, transparent 40%);
  opacity: 0.8;
}

/* Video Background Styles */
.dsp-hero-video-background {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
}

.dsp-hero-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
  filter: blur(1px);
}

.dsp-hero-video-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg,
      rgba(15, 15, 35, 0.75) 0%,
      rgba(20, 30, 60, 0.65) 40%,
      rgba(25, 40, 80, 0.7) 70%,
      rgba(20, 30, 50, 0.75) 100%);
  backdrop-filter: blur(2px);
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  padding: 120px 20px 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-content .container {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.875rem;
  margin-bottom: 0;
  position: relative;
  z-index: 3;
  align-self: flex-start;
}

.breadcrumb-link {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.2s;
}

.breadcrumb-link:hover {
  color: #fff;
}

.breadcrumb-separator {
  color: rgba(255, 255, 255, 0.5);
}

.breadcrumb-current {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

.hero-text-wrapper {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.hero-text {
  max-width: 900px;
  text-align: center;
  margin: 0 auto;
  width: 100%;
}

.hero-title {
  font-size: clamp(3rem, 6vw, 5rem);
  font-weight: 800;
  color: #ffffff;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  text-align: center;
  letter-spacing: -0.02em;
}

.hero-subtitle {
  font-size: clamp(1rem, 2vw, 1.25rem);
  color: rgba(255, 255, 255, 0.95);
  line-height: 1.7;
  margin-bottom: 2.5rem;
  text-align: center;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.hero-actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.btn-primary-hero {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 32px;
  background: #4a9eff;
  color: #ffffff;
  font-weight: 600;
  font-size: 1rem;
  text-decoration: none;
  border-radius: 6px;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  min-width: 150px;
}

.btn-primary-hero:hover {
  background: #3a8eef;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(74, 158, 255, 0.4);
}

.btn-secondary-hero {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 32px;
  background: transparent;
  color: #ffffff;
  font-weight: 600;
  font-size: 1rem;
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 6px;
  transition: all 0.3s ease;
  cursor: pointer;
  min-width: 150px;
}

.btn-secondary-hero:hover {
  border-color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

/* Responsive Hero Section */
@media (max-width: 480px) {
  .dsp-hero-section {
    min-height: 100vh;
    height: auto;
  }

  .hero-content {
    padding: 70px 12px 30px;
  }

  .breadcrumb-nav {
    font-size: 0.7rem;
    gap: 0.4rem;
    margin-bottom: 1rem;
  }

  .hero-title {
    font-size: clamp(1.75rem, 10vw, 2.5rem);
  }

  .hero-subtitle {
    font-size: clamp(0.85rem, 4vw, 1rem);
  }

  .btn-primary-hero,
  .btn-secondary-hero {
    max-width: 100%;
    font-size: 0.85rem;
    padding: 10px 20px;
  }
}

/* Content Section */
.dsp-content-section {
  padding: 4rem 2rem;
}

.dsp-content-section .container {
  max-width: 1200px;
  margin: 0 auto;
}

/* Tabs */
.dsp-tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 2rem;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 0;
}

.dsp-tab {
  padding: 1rem 2rem;
  background: transparent;
  border: none;
  font-size: 1rem;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
}

.dsp-tab::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background: transparent;
  transition: background 0.3s ease;
}

.dsp-tab:hover {
  color: #1a1a2e;
}

.dsp-tab.active {
  color: #4a9eff;
}

.dsp-tab.active::after {
  background: #4a9eff;
}

/* Overview Panel */
.dsp-overview-panel {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.6s ease;
}

.dsp-overview-panel.visible {
  opacity: 1;
  transform: translateY(0);
}

.dsp-overview-grid {
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 3rem;
}

.dsp-full-width-grid {
  grid-template-columns: 1fr;
  gap: 0;
}

.dsp-full-width-main {
  width: 100%;
  max-width: 100%;
}

.dsp-overview-main h2 {
  font-size: 2rem;
  color: #1a1a2e;
  margin-bottom: 2.5rem;
  font-weight: 700;
}

.dsp-full-width-main h2 {
  margin-bottom: 3rem;
}

.dsp-overview-main p {
  font-size: 1.0625rem;
  color: #4b5563;
  line-height: 1.8;
  margin-bottom: 1.5rem;
}

/* Product Slider */
.product-slider-container {
  margin-top: 2rem;
  padding: 1.5rem 0;
  width: 100%;
}

.product-slider-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.product-slider {
  display: flex;
  gap: 1.5rem;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  flex: 1 1;
  padding: 1rem 0;
}

.product-slider::-webkit-scrollbar {
  display: none;
}

.product-slide {
  flex: 0 0 200px;
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: 0.6;
  transform: scale(0.95);
}

.product-slide.active {
  opacity: 1;
  transform: scale(1);
}

.product-slide:hover {
  opacity: 0.9;
  transform: scale(1.02);
}

.product-slide-image {
  width: 100%;
  height: 200px;
  border-radius: 12px;
  overflow: hidden;
  background: #f3f4f6;
  margin-bottom: 0.75rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.product-slide.active .product-slide-image {
  box-shadow: 0 8px 24px rgba(74, 158, 255, 0.3);
  border: 2px solid #4a9eff;
}

.product-slide-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.product-slide:hover .product-slide-image img {
  transform: scale(1.05);
}

.product-slide-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e5e7eb 0%, #f3f4f6 100%);
}

.product-slide-placeholder svg {
  color: #9ca3af;
}

.product-slide-name {
  text-align: center;
  font-size: 0.875rem;
  font-weight: 600;
  color: #1a1a2e;
  padding: 0.5rem;
}

.product-slide.active .product-slide-name {
  color: #4a9eff;
}

.slider-nav-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid #e5e7eb;
  background: #fff;
  color: #4a9eff;
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.slider-nav-btn:hover {
  background: #4a9eff;
  color: #fff;
  border-color: #4a9eff;
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(74, 158, 255, 0.3);
}

.slider-nav-btn:active {
  transform: scale(0.95);
}

.slider-dots {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 1.5rem;
  flex-wrap: wrap;
}

.slider-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  background: #d1d5db;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
}

.slider-dot:hover {
  background: #9ca3af;
  transform: scale(1.2);
}

.slider-dot.active {
  background: #4a9eff;
  width: 24px;
  border-radius: 5px;
}

@media (max-width: 1024px) {
  .dsp-overview-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .dsp-overview-sidebar {
    position: static;
    order: -1;
  }

  .current-product-image {
    min-height: 300px;
    max-height: 400px;
  }
}

@media (max-width: 768px) {
  .product-slider {
    gap: 1rem;
  }

  .product-slide {
    flex: 0 0 150px;
  }

  .product-slide-image {
    height: 150px;
  }

  .slider-nav-btn {
    width: 40px;
    height: 40px;
    font-size: 1.25rem;
  }

  .product-slider-wrapper {
    gap: 0.5rem;
  }

  .current-product-image {
    min-height: 250px;
    max-height: 350px;
  }
}

/* Features Section */
.dsp-features-section,
.dsp-benefits-section {
  margin-top: 3rem;
}

.dsp-features-section h3,
.dsp-benefits-section h3 {
  font-size: 1.5rem;
  color: #1a1a2e;
  margin-bottom: 1.5rem;
}

.dsp-features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  width: 100%;
  max-width: 100%;
}

.dsp-feature-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2.5rem 2rem;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.dsp-feature-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(74, 158, 255, 0.2);
  border-color: #4a9eff;
  background: linear-gradient(135deg, rgba(74, 158, 255, 0.02) 0%, rgba(44, 90, 160, 0.02) 100%);
}

.dsp-feature-card:hover .dsp-feature-number {
  transform: scale(1.1);
  background: #3a8eef;
  box-shadow: 0 4px 12px rgba(74, 158, 255, 0.3);
}

.dsp-feature-number {
  width: 80px;
  height: 80px;
  background: #4a9eff;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 2rem;
  margin-bottom: 1.5rem;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.dsp-feature-card p {
  margin: 0;
  color: #1a1a2e;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
}

/* Benefits Section */
.dsp-benefits-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  width: 100%;
  max-width: 100%;
}

.dsp-benefit-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.25rem;
  padding: 1.5rem 2rem;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.dsp-benefit-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(74, 158, 255, 0.2);
  border-color: #4a9eff;
  background: linear-gradient(135deg, rgba(74, 158, 255, 0.02) 0%, rgba(44, 90, 160, 0.02) 100%);
}

.dsp-benefit-check {
  width: 50px;
  height: 50px;
  background: #4a9eff;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.5rem;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.dsp-benefit-card:hover .dsp-benefit-check {
  transform: scale(1.1);
  background: #3a8eef;
  box-shadow: 0 4px 12px rgba(74, 158, 255, 0.3);
}

.dsp-benefit-card p {
  margin: 0;
  color: #1a1a2e;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
  flex: 1 1;
}

/* Sidebar Stats */
.dsp-overview-sidebar {
  position: sticky;
  top: 100px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.current-product-image-container {
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  margin-bottom: 2rem;
}

.current-product-image {
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 12px;
  min-height: 500px;
  max-height: 600px;
}

.dsp-stats-card {
  background: linear-gradient(135deg, #1a1a2e 0%, #1e3a5f 100%);
  border-radius: 16px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.dsp-stat {
  text-align: center;
}

.dsp-stat-number {
  display: block;
  font-size: 2.5rem;
  font-weight: 700;
  color: #4a9eff;
  line-height: 1;
}

.dsp-stat-label {
  display: block;
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* Products Panel */
.dsp-products-panel {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.6s ease;
}

.dsp-products-panel.visible {
  opacity: 1;
  transform: translateY(0);
}

.dsp-products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
}

.dsp-product-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: all 0.4s ease;
  animation: fadeInUp 0.6s ease forwards;
  opacity: 0;
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }

  from {
    opacity: 0;
    transform: translateY(20px);
  }
}

.dsp-product-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
}

.dsp-product-image {
  height: 200px;
  overflow: hidden;
  background: #f3f4f6;
}

.dsp-product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.dsp-product-card:hover .dsp-product-image img {
  transform: scale(1.05);
}

.dsp-product-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e5e7eb 0%, #f3f4f6 100%);
}

.dsp-placeholder-icon {
  color: #9ca3af;
}

.dsp-product-info {
  padding: 1.5rem;
}

.dsp-product-name {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 0.5rem;
}

.dsp-product-desc {
  font-size: 0.875rem;
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.dsp-product-btn {
  display: inline-block;
  padding: 0.5rem 0;
  background: transparent;
  border: none;
  color: #8b5cf6;
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
  transition: color 0.2s;
}

.dsp-product-btn:hover {
  color: #6366f1;
}

.dsp-no-products {
  text-align: center;
  padding: 4rem 2rem;
  background: #fff;
  border-radius: 16px;
  border: 2px dashed #e5e7eb;
}

.dsp-no-products p {
  color: #6b7280;
  margin-bottom: 1.5rem;
}

/* Full Width Product Slider */
.full-width-product-slider-section {
  padding: 4rem 2rem;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-top: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  width: 100%;
  box-sizing: border-box;
}

.full-width-product-slider-section .container {
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  padding: 0 1rem;
  box-sizing: border-box;
}

.slider-section-title {
  font-size: clamp(1.5rem, 4vw, 1.75rem);
  font-weight: 700;
  color: #1a1a2e;
  text-align: center;
  margin-bottom: 2.5rem;
  padding: 0;
}

.full-width-slider-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  gap: clamp(0.75rem, 2vw, 1.5rem);
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0;
  box-sizing: border-box;
  justify-content: center;
}

.full-width-product-slider {
  display: flex;
  gap: clamp(1.25rem, 2.5vw, 2rem);
  overflow-x: hidden;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  flex: 1 1;
  padding: 0;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  align-items: stretch;
  justify-content: center;
}

.full-width-product-slider::-webkit-scrollbar {
  display: none;
}

.full-width-slide {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(33.333% - 1.33rem);
  min-width: 280px;
  max-width: 380px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 480px;
  box-sizing: border-box;
  border: 1px solid transparent;
}

.full-width-slide.active {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 2px solid #4a9eff;
  transform: none;
}

.full-width-slide:hover:not(.active) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.full-slide-image {
  width: 100%;
  height: clamp(240px, 28vw, 300px);
  min-height: 240px;
  max-height: 300px;
  overflow: hidden;
  background: #ffffff;
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.full-slide-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  transition: transform 0.3s ease;
  display: block;
  background-color: #ffffff;
  padding: 1rem;
}

/* Ensure images load properly and maintain aspect ratio */
.full-slide-image img[src] {
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  image-rendering: auto;
}

.full-width-slide:hover .full-slide-image img {
  transform: scale(1.05);
}

.full-slide-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  width: 100%;
  height: 100%;
}

.full-slide-placeholder svg {
  color: #9ca3af;
  width: 80px;
  height: 80px;
  opacity: 0.6;
}

.full-slide-info {
  padding: 1.5rem !important;
  display: flex !important;
  flex-direction: column !important;
  background: #fff !important;
  flex: 0 0 auto !important;
  flex-shrink: 0 !important;
  min-height: 160px !important;
  box-sizing: border-box !important;
  justify-content: flex-start !important;
  visibility: visible !important;
  opacity: 1 !important;
  overflow: visible !important;
  width: 100% !important;
  position: relative !important;
  z-index: 1 !important;
}

.full-slide-name {
  font-size: clamp(1.125rem, 2vw, 1.25rem) !important;
  font-weight: 700 !important;
  color: #1a1a2e !important;
  margin: 0 0 0.75rem 0 !important;
  padding: 0 !important;
  line-height: 1.4 !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  display: block !important;
  text-align: left !important;
  width: 100% !important;
  visibility: visible !important;
  opacity: 1 !important;
  overflow: visible !important;
  position: relative !important;
  z-index: 2 !important;
}

.full-width-slide.active .full-slide-name {
  color: #4a9eff;
}

.full-width-slide:hover .full-slide-name {
  color: #4a9eff;
  transition: color 0.3s ease;
}

.full-slide-desc {
  font-size: clamp(0.875rem, 1.5vw, 0.9375rem) !important;
  color: #6b7280 !important;
  line-height: 1.6 !important;
  margin: 0 !important;
  padding: 0 !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 3 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  visibility: visible !important;
  opacity: 1 !important;
  position: relative !important;
  z-index: 2 !important;
  width: 100% !important;
}

.full-slider-nav-btn {
  width: clamp(44px, 5vw, 56px);
  height: clamp(44px, 5vw, 56px);
  border-radius: 50%;
  border: 2px solid #e5e7eb;
  background: #fff;
  color: #6b7280;
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  z-index: 2;
}

.full-slider-nav-btn:hover:not(:disabled) {
  background: #f9fafb;
  color: #4a9eff;
  border-color: #d1d5db;
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.full-slider-nav-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.full-slider-nav-btn:active:not(:disabled) {
  transform: scale(0.95);
}

.full-slider-dots {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 2rem;
  flex-wrap: wrap;
  padding: 0 1rem;
}

.full-slider-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: none;
  background: #d1d5db;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
}

.full-slider-dot:hover {
  background: #9ca3af;
  transform: scale(1.2);
}

.full-slider-dot.active {
  background: #4a9eff;
  width: 28px;
  border-radius: 6px;
}

/* Tablet and Medium Screens */
@media (max-width: 1200px) and (min-width: 769px) {
  .full-width-slide {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(33.333% - 1.33rem);
    min-width: 260px;
    min-height: 460px;
  }

  .full-slide-image {
    height: clamp(220px, 28vw, 260px) !important;
    max-height: 260px !important;
  }

  .full-slide-info {
    min-height: 150px !important;
    display: flex !important;
    visibility: visible !important;
    opacity: 1 !important;
  }

  .full-slide-name {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }

  .full-slide-desc {
    visibility: visible !important;
    opacity: 1 !important;
  }
}

/* Large Desktop Screens (>1366px) */
@media (min-width: 1367px) {
  .full-width-slide {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(33.333% - 1.33rem);
    min-width: 300px;
    max-width: 400px;
    min-height: 500px;
  }

  .full-slide-image {
    height: 280px !important;
    min-height: 280px !important;
    max-height: 280px !important;
  }

  .full-slide-info {
    padding: 1.75rem !important;
    min-height: 180px !important;
    display: flex !important;
    flex-direction: column !important;
    visibility: visible !important;
    opacity: 1 !important;
    flex: 0 0 auto !important;
  }

  .full-slide-name {
    font-size: 1.3rem !important;
    font-weight: 700 !important;
    color: #1a1a2e !important;
    margin: 0 0 1rem 0 !important;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }

  .full-slide-desc {
    font-size: 1rem !important;
    color: #6b7280 !important;
    display: -webkit-box !important;
    -webkit-line-clamp: 3 !important;
    -webkit-box-orient: vertical !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
}

/* Laptop Screens (1024px - 1366px) */
@media (min-width: 1024px) and (max-width: 1366px) {
  .full-width-slide {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(33.333% - 1.33rem);
    min-width: 280px;
    max-width: 360px;
    min-height: 480px;
  }

  .full-slide-image {
    height: 260px !important;
    min-height: 260px !important;
    max-height: 260px !important;
  }

  .full-slide-info {
    padding: 1.5rem !important;
    min-height: 160px !important;
    display: flex !important;
    flex-direction: column !important;
    visibility: visible !important;
    opacity: 1 !important;
    flex: 0 0 auto !important;
  }

  .full-slide-name {
    font-size: 1.2rem !important;
    font-weight: 700 !important;
    color: #1a1a2e !important;
    margin: 0 0 0.75rem 0 !important;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }

  .full-slide-desc {
    font-size: 0.9375rem !important;
    color: #6b7280 !important;
    display: -webkit-box !important;
    -webkit-line-clamp: 3 !important;
    -webkit-box-orient: vertical !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
}

@media (max-width: 1024px) {
  .full-width-product-slider-section {
    padding: 3rem 1.5rem;
  }

  .full-width-slide {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 1rem);
    min-width: 280px;
  }

  .full-slide-image {
    height: clamp(200px, 30vw, 280px);
    min-height: 200px;
  }

  .full-slide-info {
    padding: 1.5rem;
    min-height: 140px;
    display: flex !important;
    visibility: visible !important;
    opacity: 1 !important;
  }

  .full-slide-name {
    font-size: 1.125rem !important;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }

  .full-slide-desc {
    display: -webkit-box !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
}

/* Tablet Portrait */
@media (max-width: 768px) {
  .full-width-product-slider-section {
    padding: 3rem 1rem;
  }

  .slider-section-title {
    margin-bottom: 2rem;
    padding: 0;
  }

  .full-width-slider-wrapper {
    gap: 0.75rem;
  }

  .full-width-product-slider {
    gap: 1rem;
  }

  .full-width-slide {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 0.5rem);
    min-width: 250px;
  }

  .full-slide-image {
    height: clamp(180px, 35vw, 240px);
    min-height: 180px;
  }

  .full-slide-info {
    padding: 1.25rem;
    min-height: 100px;
  }

  .full-slider-nav-btn {
    width: 44px;
    height: 44px;
    font-size: 1.5rem;
  }
}

/* Mobile Landscape */
@media (max-width: 640px) {
  .full-width-product-slider-section {
    padding: 2.5rem 1rem;
  }

  .slider-section-title {
    font-size: 1.375rem;
    margin-bottom: 1.75rem;
  }

  .full-width-slide {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 0.5rem);
  }

  .full-slide-image {
    height: clamp(140px, 40vw, 200px);
  }

  .full-slide-info {
    padding: 1rem;
  }

  .full-slider-dots {
    margin-top: 1.5rem;
    gap: 0.5rem;
  }
}

/* Mobile Portrait */
@media (max-width: 480px) {
  .full-width-product-slider-section {
    padding: 2rem 0.75rem;
  }

  .slider-section-title {
    font-size: 1.25rem;
    margin-bottom: 1.5rem;
  }

  .full-width-slider-wrapper {
    gap: 0.5rem;
  }

  .full-width-product-slider {
    gap: 0.75rem;
  }

  .full-width-slide {
    flex: 0 0 85%;
    min-width: 240px;
  }

  .full-slide-image {
    height: 200px;
    min-height: 200px;
  }

  .full-slide-info {
    padding: 1rem;
    min-height: 100px;
  }

  .full-slide-name {
    font-size: 1.125rem;
    margin-bottom: 0.625rem;
    font-weight: 700;
  }

  .full-slide-desc {
    font-size: 0.875rem;
    -webkit-line-clamp: 3;
  }

  .full-slider-nav-btn {
    width: 40px;
    height: 40px;
    font-size: 1.25rem;
  }

  .full-slider-dots {
    margin-top: 1.25rem;
    gap: 0.5rem;
  }

  .full-slider-dot {
    width: 10px;
    height: 10px;
  }

  .full-slider-dot.active {
    width: 24px;
  }
}

/* Extra Small Mobile */
@media (max-width: 360px) {
  .full-width-product-slider-section {
    padding: 1.5rem 0.5rem;
  }

  .full-width-slide {
    flex: 0 0 92%;
  }

  .full-slide-image {
    height: 160px;
  }

  .full-slide-info {
    padding: 0.75rem;
  }
}

/* Related Section */
.dsp-related-section {
  padding: 4rem 2rem;
  background: #fff;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.6s ease;
}

.dsp-related-section.visible {
  opacity: 1;
  transform: translateY(0);
}

.dsp-related-section .container {
  max-width: 1200px;
  margin: 0 auto;
}

.dsp-related-title {
  font-family: 'Playfair Display', Georgia, serif;
  font-size: 2rem;
  color: #1a1a2e;
  text-align: center;
  margin-bottom: 3rem;
}

.dsp-related-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.dsp-related-card {
  display: block;
  padding: 2rem;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 12px;
  text-decoration: none;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.dsp-related-card:hover {
  background: linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%);
  border-color: transparent;
  transform: translateY(-4px);
}

.dsp-related-content h3 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 0.5rem;
  transition: color 0.3s;
}

.dsp-related-card:hover h3 {
  color: #fff;
}

.dsp-related-count {
  display: block;
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 0.5rem;
  transition: color 0.3s;
}

.dsp-related-card:hover .dsp-related-count {
  color: rgba(255, 255, 255, 0.8);
}

.dsp-related-arrow {
  font-size: 1.25rem;
  color: #8b5cf6;
  transition: all 0.3s;
}

.dsp-related-card:hover .dsp-related-arrow {
  color: #fff;
  transform: translateX(4px);
}

/* CTA Section */
.dsp-cta-section {
  padding: 5rem 2rem;
  background: linear-gradient(135deg, #1a1a2e 0%, #2d1b4e 100%);
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.6s ease;
}

.dsp-cta-section.visible {
  opacity: 1;
  transform: translateY(0);
}

.dsp-cta-section .container {
  max-width: 800px;
  margin: 0 auto;
}

.dsp-cta-content {
  text-align: center;
}

.dsp-cta-content h2 {
  font-family: 'Playfair Display', Georgia, serif;
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 1rem;
}

.dsp-cta-content p {
  font-size: 1.125rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.dsp-cta-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.dsp-cta-primary {
  display: inline-flex;
  padding: 1rem 2.5rem;
  background: linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%);
  color: #fff;
  font-weight: 600;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.dsp-cta-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.4);
}

.dsp-cta-secondary {
  display: inline-flex;
  padding: 1rem 2.5rem;
  background: transparent;
  color: #fff;
  font-weight: 600;
  text-decoration: none;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  transition: all 0.3s ease;
}

.dsp-cta-secondary:hover {
  border-color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

/* Modal Styles */
.dsp-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.dsp-modal {
  background: #fff;
  border-radius: 20px;
  max-width: 700px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  animation: slideUp 0.4s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dsp-modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 40px;
  height: 40px;
  border: none;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 1;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dsp-modal-close:hover {
  background: rgba(0, 0, 0, 0.2);
}

.dsp-modal-image {
  height: 300px;
  overflow: hidden;
}

.dsp-modal-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dsp-modal-content {
  padding: 2rem;
}

.dsp-modal-content h2 {
  font-family: 'Playfair Display', Georgia, serif;
  font-size: 1.75rem;
  color: #1a1a2e;
  margin-bottom: 1.5rem;
}

.dsp-modal-section {
  margin-bottom: 1.5rem;
}

.dsp-modal-section h4 {
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #8b5cf6;
  margin-bottom: 0.5rem;
}

.dsp-modal-section p {
  color: #4b5563;
  line-height: 1.7;
}

.dsp-modal-btn {
  display: inline-flex;
  width: 100%;
  padding: 1rem;
  background: linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%);
  color: #fff;
  font-weight: 600;
  text-decoration: none;
  border-radius: 8px;
  justify-content: center;
  transition: all 0.3s ease;
  margin-top: 1rem;
}

.dsp-modal-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.4);
}

/* Responsive Styles */
@media (max-width: 992px) {
  .hero-content {
    padding: 100px 20px 60px;
  }

  .hero-text {
    max-width: 100%;
    padding: 0 1rem;
  }

  .dsp-overview-grid {
    grid-template-columns: 1fr;
  }

  .dsp-overview-sidebar {
    position: static;
  }

  .dsp-stats-card {
    flex-direction: row;
    justify-content: space-around;
  }

  .dsp-features-grid,
  .dsp-benefits-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .dsp-hero-section {
    min-height: 100vh;
    height: auto;
  }

  .hero-content {
    padding: 80px 15px 40px;
  }

  .hero-content .container {
    gap: 1.5rem;
  }

  .breadcrumb-nav {
    font-size: 0.75rem;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
  }

  .hero-text-wrapper {
    padding-top: 0;
  }

  .hero-title {
    font-size: clamp(2rem, 8vw, 3.5rem);
    margin-bottom: 1rem;
  }

  .hero-subtitle {
    font-size: clamp(0.9rem, 3vw, 1.1rem);
    margin-bottom: 2rem;
    line-height: 1.6;
  }

  .hero-actions {
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
  }

  .btn-primary-hero,
  .btn-secondary-hero {
    width: 100%;
    max-width: 280px;
    justify-content: center;
    padding: 12px 24px;
    font-size: 0.9rem;
  }

  .dsp-tabs {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .dsp-tab {
    padding: 0.75rem 1.25rem;
    white-space: nowrap;
  }

  .dsp-content-section {
    padding: 2rem 1rem;
  }

  .dsp-products-grid {
    grid-template-columns: 1fr;
  }

  .dsp-features-grid,
  .dsp-benefits-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }

  .dsp-feature-card {
    padding: 2rem 1.5rem;
  }

  .dsp-benefit-card {
    padding: 1.25rem 1.5rem;
  }

  .dsp-feature-number {
    width: 70px;
    height: 70px;
    font-size: 1.75rem;
    margin-bottom: 1.25rem;
  }

  .dsp-benefit-check {
    width: 45px;
    height: 45px;
    font-size: 1.25rem;
  }

  .dsp-feature-card p,
  .dsp-benefit-card p {
    font-size: 0.9375rem;
  }

  .dsp-stats-card {
    flex-direction: column;
    gap: 1.5rem;
  }

  .dsp-features-grid,
  .dsp-benefits-grid {
    grid-template-columns: 1fr;
    gap: 1.25rem;
  }

  .dsp-feature-card {
    padding: 2rem 1.25rem;
  }

  .dsp-benefit-card {
    padding: 1.25rem 1.5rem;
    gap: 1rem;
  }

  .dsp-feature-number {
    width: 60px;
    height: 60px;
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  .dsp-benefit-check {
    width: 40px;
    height: 40px;
    font-size: 1.125rem;
  }

  .dsp-related-section {
    padding: 3rem 1rem;
  }

  .dsp-cta-section {
    padding: 3rem 1rem;
  }

  .dsp-cta-content h2 {
    font-size: 1.75rem;
  }

  .dsp-cta-buttons {
    flex-direction: column;
  }

  .dsp-cta-primary,
  .dsp-cta-secondary {
    width: 100%;
    justify-content: center;
  }

  .dsp-modal {
    margin: 1rem;
    max-height: calc(100vh - 2rem);
  }

  .dsp-modal-image {
    height: 200px;
  }
}

/* Fade in animation helper */
.fade-in-section {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.6s ease;
}

.fade-in-section.visible {
  opacity: 1;
  transform: translateY(0);
}`, "",{"version":3,"sources":["webpack://./src/pages/DynamicServicePage.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,uFAAuF;AACzF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;mFAGiF;EACjF,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;kCAIgC;EAChC,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,0CAA0C;EAC1C,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;;IAEE,eAAe;IACf,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,MAAM;AACR;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,qBAAqB;AACrB;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,qBAAqB;EACrB,8FAA8F;AAChG;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,qBAAqB;EACrB,8FAA8F;AAChG;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAO;AACT;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,sCAAsC;EACtC,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,6BAA6B;EAC7B,gCAAgC;EAChC,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,cAAc;EACd,UAAU;EACV,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,SAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAiC;EAAjC,cAAiC;EAAjC,mCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,cAAc;EACd,yBAAyB;EACzB,aAAa;AACf;;AAEA,0DAA0D;AAC1D;EACE,0CAA0C;EAC1C,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,iCAAiC;EACjC,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;EAC5B,iCAAiC;EACjC,sCAAsC;EACtC,8BAA8B;EAC9B,qBAAqB;EACrB,4BAA4B;EAC5B,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,mDAAmD;EACnD,2BAA2B;EAC3B,yBAAyB;EACzB,gCAAgC;EAChC,qBAAqB;EACrB,2BAA2B;EAC3B,gCAAgC;EAChC,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;EACrB,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,uDAAuD;EACvD,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,+BAA+B;EAC/B,gCAAgC;EAChC,uCAAuC;EACvC,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B;EAC9B,qBAAqB;EACrB,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE;IACE,YAAiC;IAAjC,cAAiC;IAAjC,mCAAiC;IACjC,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,4CAA4C;IAC5C,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;IAC5B,wBAAwB;IACxB,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;IAC9B,qBAAqB;EACvB;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,YAAiC;IAAjC,cAAiC;IAAjC,mCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;IAC3B,yBAAyB;IACzB,6BAA6B;IAC7B,yBAAyB;IACzB,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,+BAA+B;IAC/B,gCAAgC;IAChC,uCAAuC;IACvC,8BAA8B;IAC9B,qBAAqB;EACvB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,YAAiC;IAAjC,cAAiC;IAAjC,mCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;IAC3B,yBAAyB;IACzB,gCAAgC;IAChC,yBAAyB;IACzB,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,+BAA+B;IAC/B,yBAAyB;IACzB,+BAA+B;IAC/B,gCAAgC;IAChC,uCAAuC;IACvC,8BAA8B;IAC9B,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;IAC9B,yBAAyB;IACzB,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,+BAA+B;IAC/B,8BAA8B;IAC9B,qBAAqB;EACvB;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAA4B;IAA5B,cAA4B;IAA5B,8BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,YAA4B;IAA5B,cAA4B;IAA5B,8BAA4B;EAC9B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,6DAA6D;EAC7D,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,0CAA0C;EAC1C,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,aAAa;EACb,6DAA6D;EAC7D,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,sBAAsB;AACtB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;;IAEE,qCAAqC;IACrC,WAAW;EACb;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mCAAmC;IACnC,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,6BAA6B;AAC7B;EACE,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B","sourcesContent":["/* Dynamic Service Page Styles */\n.dynamic-service-page {\n  min-height: 100vh;\n  background: #fafafa;\n}\n\n/* Loading & Error States */\n.loading-container,\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  padding: 2rem;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #e0e0e0;\n  border-top-color: #1a1a2e;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.error-container h2 {\n  color: #d32f2f;\n  margin-bottom: 1rem;\n}\n\n/* Hero Section */\n.dsp-hero-section {\n  position: relative;\n  min-height: 100vh;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.dsp-hero-gradient {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg, #0a0a1a 0%, #0f1520 40%, #141e30 70%, #0f0f1f 100%);\n}\n\n.dsp-hero-pattern {\n  position: absolute;\n  inset: 0;\n  background-image:\n    radial-gradient(circle at 20% 50%, rgba(74, 158, 255, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(74, 158, 255, 0.08) 0%, transparent 40%),\n    radial-gradient(circle at 40% 80%, rgba(44, 90, 160, 0.06) 0%, transparent 40%);\n  opacity: 0.8;\n}\n\n/* Video Background Styles */\n.dsp-hero-video-background {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  z-index: 0;\n}\n\n.dsp-hero-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  min-width: 100%;\n  min-height: 100%;\n  filter: blur(1px);\n}\n\n.dsp-hero-video-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg,\n      rgba(15, 15, 35, 0.75) 0%,\n      rgba(20, 30, 60, 0.65) 40%,\n      rgba(25, 40, 80, 0.7) 70%,\n      rgba(20, 30, 50, 0.75) 100%);\n  backdrop-filter: blur(2px);\n  z-index: 1;\n}\n\n.hero-content {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  padding: 120px 20px 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.hero-content .container {\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 0.875rem;\n  margin-bottom: 0;\n  position: relative;\n  z-index: 3;\n  align-self: flex-start;\n}\n\n.breadcrumb-link {\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.breadcrumb-link:hover {\n  color: #fff;\n}\n\n.breadcrumb-separator {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.breadcrumb-current {\n  color: rgba(255, 255, 255, 0.9);\n  font-weight: 500;\n}\n\n.hero-text-wrapper {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.hero-text {\n  max-width: 900px;\n  text-align: center;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.hero-title {\n  font-size: clamp(3rem, 6vw, 5rem);\n  font-weight: 800;\n  color: #ffffff;\n  line-height: 1.2;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  letter-spacing: -0.02em;\n}\n\n.hero-subtitle {\n  font-size: clamp(1rem, 2vw, 1.25rem);\n  color: rgba(255, 255, 255, 0.95);\n  line-height: 1.7;\n  margin-bottom: 2.5rem;\n  text-align: center;\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.hero-actions {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n}\n\n.btn-primary-hero {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 14px 32px;\n  background: #4a9eff;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 1rem;\n  text-decoration: none;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n  border: none;\n  cursor: pointer;\n  min-width: 150px;\n}\n\n.btn-primary-hero:hover {\n  background: #3a8eef;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(74, 158, 255, 0.4);\n}\n\n.btn-secondary-hero {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 14px 32px;\n  background: transparent;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 1rem;\n  text-decoration: none;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  border-radius: 6px;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  min-width: 150px;\n}\n\n.btn-secondary-hero:hover {\n  border-color: #ffffff;\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateY(-2px);\n}\n\n/* Responsive Hero Section */\n@media (max-width: 480px) {\n  .dsp-hero-section {\n    min-height: 100vh;\n    height: auto;\n  }\n\n  .hero-content {\n    padding: 70px 12px 30px;\n  }\n\n  .breadcrumb-nav {\n    font-size: 0.7rem;\n    gap: 0.4rem;\n    margin-bottom: 1rem;\n  }\n\n  .hero-title {\n    font-size: clamp(1.75rem, 10vw, 2.5rem);\n  }\n\n  .hero-subtitle {\n    font-size: clamp(0.85rem, 4vw, 1rem);\n  }\n\n  .btn-primary-hero,\n  .btn-secondary-hero {\n    max-width: 100%;\n    font-size: 0.85rem;\n    padding: 10px 20px;\n  }\n}\n\n/* Content Section */\n.dsp-content-section {\n  padding: 4rem 2rem;\n}\n\n.dsp-content-section .container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Tabs */\n.dsp-tabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 2rem;\n  border-bottom: 2px solid #e5e7eb;\n  padding-bottom: 0;\n}\n\n.dsp-tab {\n  padding: 1rem 2rem;\n  background: transparent;\n  border: none;\n  font-size: 1rem;\n  font-weight: 500;\n  color: #6b7280;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.dsp-tab::after {\n  content: '';\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: transparent;\n  transition: background 0.3s ease;\n}\n\n.dsp-tab:hover {\n  color: #1a1a2e;\n}\n\n.dsp-tab.active {\n  color: #4a9eff;\n}\n\n.dsp-tab.active::after {\n  background: #4a9eff;\n}\n\n/* Overview Panel */\n.dsp-overview-panel {\n  opacity: 0;\n  transform: translateY(20px);\n  transition: all 0.6s ease;\n}\n\n.dsp-overview-panel.visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.dsp-overview-grid {\n  display: grid;\n  grid-template-columns: 1fr 400px;\n  gap: 3rem;\n}\n\n.dsp-full-width-grid {\n  grid-template-columns: 1fr;\n  gap: 0;\n}\n\n.dsp-full-width-main {\n  width: 100%;\n  max-width: 100%;\n}\n\n.dsp-overview-main h2 {\n  font-size: 2rem;\n  color: #1a1a2e;\n  margin-bottom: 2.5rem;\n  font-weight: 700;\n}\n\n.dsp-full-width-main h2 {\n  margin-bottom: 3rem;\n}\n\n.dsp-overview-main p {\n  font-size: 1.0625rem;\n  color: #4b5563;\n  line-height: 1.8;\n  margin-bottom: 1.5rem;\n}\n\n/* Product Slider */\n.product-slider-container {\n  margin-top: 2rem;\n  padding: 1.5rem 0;\n  width: 100%;\n}\n\n.product-slider-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.product-slider {\n  display: flex;\n  gap: 1.5rem;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  flex: 1;\n  padding: 1rem 0;\n}\n\n.product-slider::-webkit-scrollbar {\n  display: none;\n}\n\n.product-slide {\n  flex: 0 0 200px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  opacity: 0.6;\n  transform: scale(0.95);\n}\n\n.product-slide.active {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.product-slide:hover {\n  opacity: 0.9;\n  transform: scale(1.02);\n}\n\n.product-slide-image {\n  width: 100%;\n  height: 200px;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #f3f4f6;\n  margin-bottom: 0.75rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.product-slide.active .product-slide-image {\n  box-shadow: 0 8px 24px rgba(74, 158, 255, 0.3);\n  border: 2px solid #4a9eff;\n}\n\n.product-slide-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.product-slide:hover .product-slide-image img {\n  transform: scale(1.05);\n}\n\n.product-slide-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #e5e7eb 0%, #f3f4f6 100%);\n}\n\n.product-slide-placeholder svg {\n  color: #9ca3af;\n}\n\n.product-slide-name {\n  text-align: center;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #1a1a2e;\n  padding: 0.5rem;\n}\n\n.product-slide.active .product-slide-name {\n  color: #4a9eff;\n}\n\n.slider-nav-btn {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: 2px solid #e5e7eb;\n  background: #fff;\n  color: #4a9eff;\n  font-size: 1.5rem;\n  font-weight: bold;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.slider-nav-btn:hover {\n  background: #4a9eff;\n  color: #fff;\n  border-color: #4a9eff;\n  transform: scale(1.1);\n  box-shadow: 0 4px 12px rgba(74, 158, 255, 0.3);\n}\n\n.slider-nav-btn:active {\n  transform: scale(0.95);\n}\n\n.slider-dots {\n  display: flex;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-top: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.slider-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  border: none;\n  background: #d1d5db;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  padding: 0;\n}\n\n.slider-dot:hover {\n  background: #9ca3af;\n  transform: scale(1.2);\n}\n\n.slider-dot.active {\n  background: #4a9eff;\n  width: 24px;\n  border-radius: 5px;\n}\n\n@media (max-width: 1024px) {\n  .dsp-overview-grid {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n\n  .dsp-overview-sidebar {\n    position: static;\n    order: -1;\n  }\n\n  .current-product-image {\n    min-height: 300px;\n    max-height: 400px;\n  }\n}\n\n@media (max-width: 768px) {\n  .product-slider {\n    gap: 1rem;\n  }\n\n  .product-slide {\n    flex: 0 0 150px;\n  }\n\n  .product-slide-image {\n    height: 150px;\n  }\n\n  .slider-nav-btn {\n    width: 40px;\n    height: 40px;\n    font-size: 1.25rem;\n  }\n\n  .product-slider-wrapper {\n    gap: 0.5rem;\n  }\n\n  .current-product-image {\n    min-height: 250px;\n    max-height: 350px;\n  }\n}\n\n/* Features Section */\n.dsp-features-section,\n.dsp-benefits-section {\n  margin-top: 3rem;\n}\n\n.dsp-features-section h3,\n.dsp-benefits-section h3 {\n  font-size: 1.5rem;\n  color: #1a1a2e;\n  margin-bottom: 1.5rem;\n}\n\n.dsp-features-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2rem;\n  width: 100%;\n  max-width: 100%;\n}\n\n.dsp-feature-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 2.5rem 2rem;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e5e7eb;\n  transition: all 0.3s ease;\n}\n\n.dsp-feature-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 24px rgba(74, 158, 255, 0.2);\n  border-color: #4a9eff;\n  background: linear-gradient(135deg, rgba(74, 158, 255, 0.02) 0%, rgba(44, 90, 160, 0.02) 100%);\n}\n\n.dsp-feature-card:hover .dsp-feature-number {\n  transform: scale(1.1);\n  background: #3a8eef;\n  box-shadow: 0 4px 12px rgba(74, 158, 255, 0.3);\n}\n\n.dsp-feature-number {\n  width: 80px;\n  height: 80px;\n  background: #4a9eff;\n  color: #fff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 2rem;\n  margin-bottom: 1.5rem;\n  flex-shrink: 0;\n  transition: all 0.3s ease;\n}\n\n.dsp-feature-card p {\n  margin: 0;\n  color: #1a1a2e;\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.5;\n}\n\n/* Benefits Section */\n.dsp-benefits-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2rem;\n  width: 100%;\n  max-width: 100%;\n}\n\n.dsp-benefit-card {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 1.25rem;\n  padding: 1.5rem 2rem;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e5e7eb;\n  transition: all 0.3s ease;\n}\n\n.dsp-benefit-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 24px rgba(74, 158, 255, 0.2);\n  border-color: #4a9eff;\n  background: linear-gradient(135deg, rgba(74, 158, 255, 0.02) 0%, rgba(44, 90, 160, 0.02) 100%);\n}\n\n.dsp-benefit-check {\n  width: 50px;\n  height: 50px;\n  background: #4a9eff;\n  color: #fff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 1.5rem;\n  flex-shrink: 0;\n  transition: all 0.3s ease;\n}\n\n.dsp-benefit-card:hover .dsp-benefit-check {\n  transform: scale(1.1);\n  background: #3a8eef;\n  box-shadow: 0 4px 12px rgba(74, 158, 255, 0.3);\n}\n\n.dsp-benefit-card p {\n  margin: 0;\n  color: #1a1a2e;\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.5;\n  flex: 1;\n}\n\n/* Sidebar Stats */\n.dsp-overview-sidebar {\n  position: sticky;\n  top: 100px;\n  height: fit-content;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.current-product-image-container {\n  width: 100%;\n  border-radius: 16px;\n  overflow: hidden;\n  background: #fff;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.current-product-image {\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n  border-radius: 12px;\n  min-height: 500px;\n  max-height: 600px;\n}\n\n.dsp-stats-card {\n  background: linear-gradient(135deg, #1a1a2e 0%, #1e3a5f 100%);\n  border-radius: 16px;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.dsp-stat {\n  text-align: center;\n}\n\n.dsp-stat-number {\n  display: block;\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #4a9eff;\n  line-height: 1;\n}\n\n.dsp-stat-label {\n  display: block;\n  font-size: 0.875rem;\n  color: rgba(255, 255, 255, 0.7);\n  margin-top: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n/* Products Panel */\n.dsp-products-panel {\n  opacity: 0;\n  transform: translateY(20px);\n  transition: all 0.6s ease;\n}\n\n.dsp-products-panel.visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.dsp-products-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 2rem;\n}\n\n.dsp-product-card {\n  background: #fff;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e5e7eb;\n  cursor: pointer;\n  transition: all 0.4s ease;\n  animation: fadeInUp 0.6s ease forwards;\n  opacity: 0;\n}\n\n@keyframes fadeInUp {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n}\n\n.dsp-product-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);\n}\n\n.dsp-product-image {\n  height: 200px;\n  overflow: hidden;\n  background: #f3f4f6;\n}\n\n.dsp-product-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.4s ease;\n}\n\n.dsp-product-card:hover .dsp-product-image img {\n  transform: scale(1.05);\n}\n\n.dsp-product-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #e5e7eb 0%, #f3f4f6 100%);\n}\n\n.dsp-placeholder-icon {\n  color: #9ca3af;\n}\n\n.dsp-product-info {\n  padding: 1.5rem;\n}\n\n.dsp-product-name {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #1a1a2e;\n  margin-bottom: 0.5rem;\n}\n\n.dsp-product-desc {\n  font-size: 0.875rem;\n  color: #6b7280;\n  line-height: 1.6;\n  margin-bottom: 1rem;\n}\n\n.dsp-product-btn {\n  display: inline-block;\n  padding: 0.5rem 0;\n  background: transparent;\n  border: none;\n  color: #8b5cf6;\n  font-weight: 600;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.dsp-product-btn:hover {\n  color: #6366f1;\n}\n\n.dsp-no-products {\n  text-align: center;\n  padding: 4rem 2rem;\n  background: #fff;\n  border-radius: 16px;\n  border: 2px dashed #e5e7eb;\n}\n\n.dsp-no-products p {\n  color: #6b7280;\n  margin-bottom: 1.5rem;\n}\n\n/* Full Width Product Slider */\n.full-width-product-slider-section {\n  padding: 4rem 2rem;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-top: 1px solid #e5e7eb;\n  border-bottom: 1px solid #e5e7eb;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.full-width-product-slider-section .container {\n  max-width: 1400px;\n  margin: 0 auto;\n  width: 100%;\n  padding: 0 1rem;\n  box-sizing: border-box;\n}\n\n.slider-section-title {\n  font-size: clamp(1.5rem, 4vw, 1.75rem);\n  font-weight: 700;\n  color: #1a1a2e;\n  text-align: center;\n  margin-bottom: 2.5rem;\n  padding: 0;\n}\n\n.full-width-slider-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: clamp(0.75rem, 2vw, 1.5rem);\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 0;\n  box-sizing: border-box;\n  justify-content: center;\n}\n\n.full-width-product-slider {\n  display: flex;\n  gap: clamp(1.25rem, 2.5vw, 2rem);\n  overflow-x: hidden;\n  scroll-behavior: smooth;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  flex: 1;\n  padding: 0;\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  align-items: stretch;\n  justify-content: center;\n}\n\n.full-width-product-slider::-webkit-scrollbar {\n  display: none;\n}\n\n.full-width-slide {\n  flex: 0 0 calc(33.333% - 1.33rem);\n  min-width: 280px;\n  max-width: 380px;\n  background: #fff;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  min-height: 480px;\n  box-sizing: border-box;\n  border: 1px solid transparent;\n}\n\n.full-width-slide.active {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  border: 2px solid #4a9eff;\n  transform: none;\n}\n\n.full-width-slide:hover:not(.active) {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.full-slide-image {\n  width: 100%;\n  height: clamp(240px, 28vw, 300px);\n  min-height: 240px;\n  max-height: 300px;\n  overflow: hidden;\n  background: #ffffff;\n  flex-shrink: 0;\n  flex-grow: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.full-slide-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  object-position: center;\n  transition: transform 0.3s ease;\n  display: block;\n  background-color: #ffffff;\n  padding: 1rem;\n}\n\n/* Ensure images load properly and maintain aspect ratio */\n.full-slide-image img[src] {\n  image-rendering: -webkit-optimize-contrast;\n  image-rendering: crisp-edges;\n  image-rendering: auto;\n}\n\n.full-width-slide:hover .full-slide-image img {\n  transform: scale(1.05);\n}\n\n.full-slide-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f3f4f6;\n  width: 100%;\n  height: 100%;\n}\n\n.full-slide-placeholder svg {\n  color: #9ca3af;\n  width: 80px;\n  height: 80px;\n  opacity: 0.6;\n}\n\n.full-slide-info {\n  padding: 1.5rem !important;\n  display: flex !important;\n  flex-direction: column !important;\n  background: #fff !important;\n  flex: 0 0 auto !important;\n  flex-shrink: 0 !important;\n  min-height: 160px !important;\n  box-sizing: border-box !important;\n  justify-content: flex-start !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n  overflow: visible !important;\n  width: 100% !important;\n  position: relative !important;\n  z-index: 1 !important;\n}\n\n.full-slide-name {\n  font-size: clamp(1.125rem, 2vw, 1.25rem) !important;\n  font-weight: 700 !important;\n  color: #1a1a2e !important;\n  margin: 0 0 0.75rem 0 !important;\n  padding: 0 !important;\n  line-height: 1.4 !important;\n  word-wrap: break-word !important;\n  overflow-wrap: break-word !important;\n  display: block !important;\n  text-align: left !important;\n  width: 100% !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n  overflow: visible !important;\n  position: relative !important;\n  z-index: 2 !important;\n}\n\n.full-width-slide.active .full-slide-name {\n  color: #4a9eff;\n}\n\n.full-width-slide:hover .full-slide-name {\n  color: #4a9eff;\n  transition: color 0.3s ease;\n}\n\n.full-slide-desc {\n  font-size: clamp(0.875rem, 1.5vw, 0.9375rem) !important;\n  color: #6b7280 !important;\n  line-height: 1.6 !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  display: -webkit-box !important;\n  -webkit-line-clamp: 3 !important;\n  -webkit-box-orient: vertical !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n  position: relative !important;\n  z-index: 2 !important;\n  width: 100% !important;\n}\n\n.full-slider-nav-btn {\n  width: clamp(44px, 5vw, 56px);\n  height: clamp(44px, 5vw, 56px);\n  border-radius: 50%;\n  border: 2px solid #e5e7eb;\n  background: #fff;\n  color: #6b7280;\n  font-size: clamp(1.5rem, 3vw, 2rem);\n  font-weight: bold;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n  z-index: 2;\n}\n\n.full-slider-nav-btn:hover:not(:disabled) {\n  background: #f9fafb;\n  color: #4a9eff;\n  border-color: #d1d5db;\n  transform: scale(1.05);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n}\n\n.full-slider-nav-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.full-slider-nav-btn:active:not(:disabled) {\n  transform: scale(0.95);\n}\n\n.full-slider-dots {\n  display: flex;\n  justify-content: center;\n  gap: 0.75rem;\n  margin-top: 2rem;\n  flex-wrap: wrap;\n  padding: 0 1rem;\n}\n\n.full-slider-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  border: none;\n  background: #d1d5db;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  padding: 0;\n}\n\n.full-slider-dot:hover {\n  background: #9ca3af;\n  transform: scale(1.2);\n}\n\n.full-slider-dot.active {\n  background: #4a9eff;\n  width: 28px;\n  border-radius: 6px;\n}\n\n/* Tablet and Medium Screens */\n@media (max-width: 1200px) and (min-width: 769px) {\n  .full-width-slide {\n    flex: 0 0 calc(33.333% - 1.33rem);\n    min-width: 260px;\n    min-height: 460px;\n  }\n\n  .full-slide-image {\n    height: clamp(220px, 28vw, 260px) !important;\n    max-height: 260px !important;\n  }\n\n  .full-slide-info {\n    min-height: 150px !important;\n    display: flex !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n\n  .full-slide-name {\n    display: block !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n\n  .full-slide-desc {\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n}\n\n/* Large Desktop Screens (>1366px) */\n@media (min-width: 1367px) {\n  .full-width-slide {\n    flex: 0 0 calc(33.333% - 1.33rem);\n    min-width: 300px;\n    max-width: 400px;\n    min-height: 500px;\n  }\n\n  .full-slide-image {\n    height: 280px !important;\n    min-height: 280px !important;\n    max-height: 280px !important;\n  }\n\n  .full-slide-info {\n    padding: 1.75rem !important;\n    min-height: 180px !important;\n    display: flex !important;\n    flex-direction: column !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    flex: 0 0 auto !important;\n  }\n\n  .full-slide-name {\n    font-size: 1.3rem !important;\n    font-weight: 700 !important;\n    color: #1a1a2e !important;\n    margin: 0 0 1rem 0 !important;\n    display: block !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n\n  .full-slide-desc {\n    font-size: 1rem !important;\n    color: #6b7280 !important;\n    display: -webkit-box !important;\n    -webkit-line-clamp: 3 !important;\n    -webkit-box-orient: vertical !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n}\n\n/* Laptop Screens (1024px - 1366px) */\n@media (min-width: 1024px) and (max-width: 1366px) {\n  .full-width-slide {\n    flex: 0 0 calc(33.333% - 1.33rem);\n    min-width: 280px;\n    max-width: 360px;\n    min-height: 480px;\n  }\n\n  .full-slide-image {\n    height: 260px !important;\n    min-height: 260px !important;\n    max-height: 260px !important;\n  }\n\n  .full-slide-info {\n    padding: 1.5rem !important;\n    min-height: 160px !important;\n    display: flex !important;\n    flex-direction: column !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    flex: 0 0 auto !important;\n  }\n\n  .full-slide-name {\n    font-size: 1.2rem !important;\n    font-weight: 700 !important;\n    color: #1a1a2e !important;\n    margin: 0 0 0.75rem 0 !important;\n    display: block !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n\n  .full-slide-desc {\n    font-size: 0.9375rem !important;\n    color: #6b7280 !important;\n    display: -webkit-box !important;\n    -webkit-line-clamp: 3 !important;\n    -webkit-box-orient: vertical !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n}\n\n@media (max-width: 1024px) {\n  .full-width-product-slider-section {\n    padding: 3rem 1.5rem;\n  }\n\n  .full-width-slide {\n    flex: 0 0 calc(50% - 1rem);\n    min-width: 280px;\n  }\n\n  .full-slide-image {\n    height: clamp(200px, 30vw, 280px);\n    min-height: 200px;\n  }\n\n  .full-slide-info {\n    padding: 1.5rem;\n    min-height: 140px;\n    display: flex !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n\n  .full-slide-name {\n    font-size: 1.125rem !important;\n    display: block !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n\n  .full-slide-desc {\n    display: -webkit-box !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n  }\n}\n\n/* Tablet Portrait */\n@media (max-width: 768px) {\n  .full-width-product-slider-section {\n    padding: 3rem 1rem;\n  }\n\n  .slider-section-title {\n    margin-bottom: 2rem;\n    padding: 0;\n  }\n\n  .full-width-slider-wrapper {\n    gap: 0.75rem;\n  }\n\n  .full-width-product-slider {\n    gap: 1rem;\n  }\n\n  .full-width-slide {\n    flex: 0 0 calc(50% - 0.5rem);\n    min-width: 250px;\n  }\n\n  .full-slide-image {\n    height: clamp(180px, 35vw, 240px);\n    min-height: 180px;\n  }\n\n  .full-slide-info {\n    padding: 1.25rem;\n    min-height: 100px;\n  }\n\n  .full-slider-nav-btn {\n    width: 44px;\n    height: 44px;\n    font-size: 1.5rem;\n  }\n}\n\n/* Mobile Landscape */\n@media (max-width: 640px) {\n  .full-width-product-slider-section {\n    padding: 2.5rem 1rem;\n  }\n\n  .slider-section-title {\n    font-size: 1.375rem;\n    margin-bottom: 1.75rem;\n  }\n\n  .full-width-slide {\n    flex: 0 0 calc(50% - 0.5rem);\n  }\n\n  .full-slide-image {\n    height: clamp(140px, 40vw, 200px);\n  }\n\n  .full-slide-info {\n    padding: 1rem;\n  }\n\n  .full-slider-dots {\n    margin-top: 1.5rem;\n    gap: 0.5rem;\n  }\n}\n\n/* Mobile Portrait */\n@media (max-width: 480px) {\n  .full-width-product-slider-section {\n    padding: 2rem 0.75rem;\n  }\n\n  .slider-section-title {\n    font-size: 1.25rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .full-width-slider-wrapper {\n    gap: 0.5rem;\n  }\n\n  .full-width-product-slider {\n    gap: 0.75rem;\n  }\n\n  .full-width-slide {\n    flex: 0 0 85%;\n    min-width: 240px;\n  }\n\n  .full-slide-image {\n    height: 200px;\n    min-height: 200px;\n  }\n\n  .full-slide-info {\n    padding: 1rem;\n    min-height: 100px;\n  }\n\n  .full-slide-name {\n    font-size: 1.125rem;\n    margin-bottom: 0.625rem;\n    font-weight: 700;\n  }\n\n  .full-slide-desc {\n    font-size: 0.875rem;\n    -webkit-line-clamp: 3;\n  }\n\n  .full-slider-nav-btn {\n    width: 40px;\n    height: 40px;\n    font-size: 1.25rem;\n  }\n\n  .full-slider-dots {\n    margin-top: 1.25rem;\n    gap: 0.5rem;\n  }\n\n  .full-slider-dot {\n    width: 10px;\n    height: 10px;\n  }\n\n  .full-slider-dot.active {\n    width: 24px;\n  }\n}\n\n/* Extra Small Mobile */\n@media (max-width: 360px) {\n  .full-width-product-slider-section {\n    padding: 1.5rem 0.5rem;\n  }\n\n  .full-width-slide {\n    flex: 0 0 92%;\n  }\n\n  .full-slide-image {\n    height: 160px;\n  }\n\n  .full-slide-info {\n    padding: 0.75rem;\n  }\n}\n\n/* Related Section */\n.dsp-related-section {\n  padding: 4rem 2rem;\n  background: #fff;\n  opacity: 0;\n  transform: translateY(20px);\n  transition: all 0.6s ease;\n}\n\n.dsp-related-section.visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.dsp-related-section .container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.dsp-related-title {\n  font-family: 'Playfair Display', Georgia, serif;\n  font-size: 2rem;\n  color: #1a1a2e;\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.dsp-related-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n}\n\n.dsp-related-card {\n  display: block;\n  padding: 2rem;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-radius: 12px;\n  text-decoration: none;\n  border: 1px solid #e5e7eb;\n  transition: all 0.3s ease;\n}\n\n.dsp-related-card:hover {\n  background: linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%);\n  border-color: transparent;\n  transform: translateY(-4px);\n}\n\n.dsp-related-content h3 {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #1a1a2e;\n  margin-bottom: 0.5rem;\n  transition: color 0.3s;\n}\n\n.dsp-related-card:hover h3 {\n  color: #fff;\n}\n\n.dsp-related-count {\n  display: block;\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin-bottom: 0.5rem;\n  transition: color 0.3s;\n}\n\n.dsp-related-card:hover .dsp-related-count {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.dsp-related-arrow {\n  font-size: 1.25rem;\n  color: #8b5cf6;\n  transition: all 0.3s;\n}\n\n.dsp-related-card:hover .dsp-related-arrow {\n  color: #fff;\n  transform: translateX(4px);\n}\n\n/* CTA Section */\n.dsp-cta-section {\n  padding: 5rem 2rem;\n  background: linear-gradient(135deg, #1a1a2e 0%, #2d1b4e 100%);\n  opacity: 0;\n  transform: translateY(20px);\n  transition: all 0.6s ease;\n}\n\n.dsp-cta-section.visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.dsp-cta-section .container {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.dsp-cta-content {\n  text-align: center;\n}\n\n.dsp-cta-content h2 {\n  font-family: 'Playfair Display', Georgia, serif;\n  font-size: 2.5rem;\n  color: #fff;\n  margin-bottom: 1rem;\n}\n\n.dsp-cta-content p {\n  font-size: 1.125rem;\n  color: rgba(255, 255, 255, 0.8);\n  margin-bottom: 2rem;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.dsp-cta-buttons {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.dsp-cta-primary {\n  display: inline-flex;\n  padding: 1rem 2.5rem;\n  background: linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%);\n  color: #fff;\n  font-weight: 600;\n  text-decoration: none;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n}\n\n.dsp-cta-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.4);\n}\n\n.dsp-cta-secondary {\n  display: inline-flex;\n  padding: 1rem 2.5rem;\n  background: transparent;\n  color: #fff;\n  font-weight: 600;\n  text-decoration: none;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 8px;\n  transition: all 0.3s ease;\n}\n\n.dsp-cta-secondary:hover {\n  border-color: #fff;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n/* Modal Styles */\n.dsp-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(4px);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.dsp-modal {\n  background: #fff;\n  border-radius: 20px;\n  max-width: 700px;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n  animation: slideUp 0.4s ease;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.dsp-modal-close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  width: 40px;\n  height: 40px;\n  border: none;\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  font-size: 1.5rem;\n  cursor: pointer;\n  z-index: 1;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dsp-modal-close:hover {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.dsp-modal-image {\n  height: 300px;\n  overflow: hidden;\n}\n\n.dsp-modal-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.dsp-modal-content {\n  padding: 2rem;\n}\n\n.dsp-modal-content h2 {\n  font-family: 'Playfair Display', Georgia, serif;\n  font-size: 1.75rem;\n  color: #1a1a2e;\n  margin-bottom: 1.5rem;\n}\n\n.dsp-modal-section {\n  margin-bottom: 1.5rem;\n}\n\n.dsp-modal-section h4 {\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #8b5cf6;\n  margin-bottom: 0.5rem;\n}\n\n.dsp-modal-section p {\n  color: #4b5563;\n  line-height: 1.7;\n}\n\n.dsp-modal-btn {\n  display: inline-flex;\n  width: 100%;\n  padding: 1rem;\n  background: linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%);\n  color: #fff;\n  font-weight: 600;\n  text-decoration: none;\n  border-radius: 8px;\n  justify-content: center;\n  transition: all 0.3s ease;\n  margin-top: 1rem;\n}\n\n.dsp-modal-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.4);\n}\n\n/* Responsive Styles */\n@media (max-width: 992px) {\n  .hero-content {\n    padding: 100px 20px 60px;\n  }\n\n  .hero-text {\n    max-width: 100%;\n    padding: 0 1rem;\n  }\n\n  .dsp-overview-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .dsp-overview-sidebar {\n    position: static;\n  }\n\n  .dsp-stats-card {\n    flex-direction: row;\n    justify-content: space-around;\n  }\n\n  .dsp-features-grid,\n  .dsp-benefits-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .dsp-hero-section {\n    min-height: 100vh;\n    height: auto;\n  }\n\n  .hero-content {\n    padding: 80px 15px 40px;\n  }\n\n  .hero-content .container {\n    gap: 1.5rem;\n  }\n\n  .breadcrumb-nav {\n    font-size: 0.75rem;\n    gap: 0.5rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .hero-text-wrapper {\n    padding-top: 0;\n  }\n\n  .hero-title {\n    font-size: clamp(2rem, 8vw, 3.5rem);\n    margin-bottom: 1rem;\n  }\n\n  .hero-subtitle {\n    font-size: clamp(0.9rem, 3vw, 1.1rem);\n    margin-bottom: 2rem;\n    line-height: 1.6;\n  }\n\n  .hero-actions {\n    flex-direction: column;\n    gap: 0.75rem;\n    width: 100%;\n  }\n\n  .btn-primary-hero,\n  .btn-secondary-hero {\n    width: 100%;\n    max-width: 280px;\n    justify-content: center;\n    padding: 12px 24px;\n    font-size: 0.9rem;\n  }\n\n  .dsp-tabs {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .dsp-tab {\n    padding: 0.75rem 1.25rem;\n    white-space: nowrap;\n  }\n\n  .dsp-content-section {\n    padding: 2rem 1rem;\n  }\n\n  .dsp-products-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .dsp-features-grid,\n  .dsp-benefits-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1.5rem;\n  }\n\n  .dsp-feature-card {\n    padding: 2rem 1.5rem;\n  }\n\n  .dsp-benefit-card {\n    padding: 1.25rem 1.5rem;\n  }\n\n  .dsp-feature-number {\n    width: 70px;\n    height: 70px;\n    font-size: 1.75rem;\n    margin-bottom: 1.25rem;\n  }\n\n  .dsp-benefit-check {\n    width: 45px;\n    height: 45px;\n    font-size: 1.25rem;\n  }\n\n  .dsp-feature-card p,\n  .dsp-benefit-card p {\n    font-size: 0.9375rem;\n  }\n\n  .dsp-stats-card {\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n\n  .dsp-features-grid,\n  .dsp-benefits-grid {\n    grid-template-columns: 1fr;\n    gap: 1.25rem;\n  }\n\n  .dsp-feature-card {\n    padding: 2rem 1.25rem;\n  }\n\n  .dsp-benefit-card {\n    padding: 1.25rem 1.5rem;\n    gap: 1rem;\n  }\n\n  .dsp-feature-number {\n    width: 60px;\n    height: 60px;\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n  }\n\n  .dsp-benefit-check {\n    width: 40px;\n    height: 40px;\n    font-size: 1.125rem;\n  }\n\n  .dsp-related-section {\n    padding: 3rem 1rem;\n  }\n\n  .dsp-cta-section {\n    padding: 3rem 1rem;\n  }\n\n  .dsp-cta-content h2 {\n    font-size: 1.75rem;\n  }\n\n  .dsp-cta-buttons {\n    flex-direction: column;\n  }\n\n  .dsp-cta-primary,\n  .dsp-cta-secondary {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .dsp-modal {\n    margin: 1rem;\n    max-height: calc(100vh - 2rem);\n  }\n\n  .dsp-modal-image {\n    height: 200px;\n  }\n}\n\n/* Fade in animation helper */\n.fade-in-section {\n  opacity: 0;\n  transform: translateY(20px);\n  transition: all 0.6s ease;\n}\n\n.fade-in-section.visible {\n  opacity: 1;\n  transform: translateY(0);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
